"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cardVariants = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CardContainer = _interopRequireDefault(require("../cardContainer/CardContainer"));

var _CardContent = _interopRequireDefault(require("../cardContainer/CardContent"));

var _GridContainer = _interopRequireDefault(require("../../../layouts/grid/GridContainer"));

var _GridItem = _interopRequireDefault(require("../../../layouts/grid/GridItem"));

var _Typography = _interopRequireDefault(require("../../../protons/typography/Typography"));

var _Image = _interopRequireDefault(require("../../../atoms/images/image/Image"));

var _ButtonText = _interopRequireDefault(require("../../../atoms/buttons/buttonText/ButtonText"));

var _ = require("../../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CardsDiscovery = function CardsDiscovery(_ref) {
  var title = _ref.title,
      buttonText = _ref.buttonText,
      imageUrl = _ref.imageUrl,
      variant = _ref.variant,
      buttonAction = _ref.buttonAction,
      isHero = _ref.isHero;
  var Box = variant === 'large' ? _.BoxFlex : _react.Fragment;
  return /*#__PURE__*/_react.default.createElement(_CardContainer.default, {
    isGradient: isHero
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_.BoxSizing, {
    pl: variant === 'large' ? 'none' : 'small',
    pr: variant === 'large' ? 'none' : 'small'
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    alignItems: "center",
    direction: variant === 'large' ? 'column-reverse' : 'row',
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: variant === 'large' ? '12' : '8'
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    disableGutters: true,
    direction: "column",
    alignItems: variant === 'large' ? 'center' : 'flex-start'
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_.BoxSizing, {
    mb: "medium",
    mt: variant === 'large' ? 'medium' : 'none'
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: title,
    color: isHero ? 'White' : '',
    align: variant === 'large' ? 'center' : '',
    bold: true,
    variant: "h4"
  }))), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_ButtonText.default, {
    icon: "ic_chevron__right",
    iconPos: "end",
    variant: "primary",
    action: function action(event) {
      return buttonAction && buttonAction(event);
    },
    title: buttonText
  })))), /*#__PURE__*/_react.default.createElement(Box, {
    grow: variant === 'large' ? 'true' : ''
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: variant === 'large' ? '12' : '4'
  }, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: imageUrl,
    ratio: variant === 'large' ? '16x9' : '1x1'
  })))))));
};

CardsDiscovery.propTypes = {
  title: _propTypes.default.string.isRequired,
  imageUrl: _propTypes.default.string.isRequired,
  variant: _propTypes.default.oneOf(['large', 'medium']),
  buttonText: _propTypes.default.string,
  buttonAction: _propTypes.default.func.isRequired,
  isHero: _propTypes.default.bool
};
CardsDiscovery.defaultProps = {
  variant: 'medium',
  buttonText: 'Learn more',
  isHero: false
};
var cardVariants = ['large', 'medium'];
exports.cardVariants = cardVariants;
var _default = CardsDiscovery;
exports.default = _default;